import { createMessage } from "./asyncThunks";

export const createMessageBuilder = (builder) => {
  builder.addCase(createMessage.pending, (state) => {
    state.message.loading = true;
  });
  builder.addCase(createMessage.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.message.newMessage = data;
    state.message.loading = false;
  });
  builder.addCase(createMessage.rejected, (state, action) => {
    state.message.loading = false;
    state.message.error = action.error.message;
  });
};
